<template>
  <div class="app-layout">
    <Header />
    <div class="app-body">
      <SlideBar />
      <div class="app-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue";
import SlideBar from "./slideBar.vue";
export default {
  name: "Layout",
  components: {
    Header,
    SlideBar,
  },
};
</script>

<style lang="scss" scoped>
.app-layout {
  width: 100%;
}

.app-body {
  display: flex;
  height: calc(100vh - 100px);
}

.app-content {
  flex: 1;
  position: relative;
  height: 100%;
  padding: 10px;
  overflow-y: auto;
}
</style>